import Address from "src/models/address";
import type { FarmPayload } from "@/types";

export default class Farm {
  id: number;
  name: string;
  isCompany: boolean;
  address: Address;
  familySize: number;

  constructor({ id, name, is_company: isCompany, address, family_size: familySize }: FarmPayload) {
    this.id = id;
    this.name = name;
    this.isCompany = isCompany;
    this.address = new Address(address);
    this.familySize = familySize;
  }
}
